module.exports = __webpack_public_path__ + "static/media/FASNYLogoLinesFinal.26f56236.png";